// extracted by mini-css-extract-plugin
export default {"svgIconWrapper":"e05PQk"};